import React from "react";

type PROPS = {
  title: string;
  className?: string;
};

const PageTitle: React.FC<PROPS> = (props) => {
  const { title } = props;
  let className = props.className ?? "";
  className += " text-2xl font-bold";

  return <div className={className}>{title}</div>;
};

export default PageTitle;
